import { Component } from '@angular/core';

@Component({
  templateUrl: '404.component.html',
  providers: []
})
export class P404Component {

  constructor() { }

}
